import React, { useState, useEffect, useMemo } from 'react';
import { Button, TouchableOpacity, View } from 'react-native'

import api from "../../../../utils/api"
import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import { useQuery } from '@tanstack/react-query';
import { useScanTag } from './AddTagModal';
import { Image } from 'expo-image';
import Modal from '../../../../components/Modal';









function DoorRow({ door, communityId }) {
  const [sendingSignal, setSendingSignal] = useState(false);

  function openDoor() {
    setSendingSignal(true)
    api.post(`/communities/${communityId}/access/doors/${door.uuid}/open`)
      .then(({ data }) => {
        console.log("OpenDoor success", data);
        if (data.error) {
          showOpenError()
        }
      })
      .catch(({ response }) => {
        showOpenError()
        console.log("OpenDoor Error", response.data);
      })
      .finally(() => {
        setSendingSignal(false)
      })
  }

  function showOpenError() {

    alert("Error al abrir puerta")
  }

  return (
    <View style={tw`px-3 py-2 row justify-between bg-gray-100 rounded-lg`}>
      <Text style={tw`text-lg text-gray-500 flex-1`}>{door.name}</Text>

      <TouchableOpacity
        disabled={sendingSignal}
        style={tw.style(`bg-primary rounded-full px-6 py-1.6`, sendingSignal && `opacity-50`)}
        onPress={openDoor}
      >
        <Text style={tw`text-white`}>{sendingSignal ? `Abriendo` : `Abrir`}</Text>
      </TouchableOpacity>
    </View>
  )
}




function ControlPanelDetail({ panel, communityId }) {
  const { isScanning, errorResult, cardResult, scanTag } = useScanTag(panel.uuid, communityId)

  return (
    <View style={tw`px-6 py-3`}>
      <Text style={tw`text-lg text-secondary`}>{panel.name}</Text>

      {/* <Text>Sistema: online</Text> */}
      <View style={tw`row`}>
        <View style={tw.style(`rounded-full h-3 w-3`, panel.is_alive ? 'bg-green-500' : 'bg-red')}></View>
        <Text style={tw`ml-2 text-gray-500`}>{panel.is_alive ? 'En línea' : 'Desconectado'}</Text>
      </View>

      {/* <Button title='Identificar tarjeta' onPress={scanTag} /> */}

      {
        isScanning &&
        <Text style={tw`text-center text-gray-600 text-lg font-500 py-5`}>Pasa la tarjeta por el sensor...</Text>
      }
      {
        cardResult &&
        <View style={tw`py-5`}>
          <Text style={tw`text-center  text-gray-600 text-base font-500`}>Tarjeta ID:</Text>
          <Text style={tw`text-center text-lg font-500`} selectable={true}>{cardResult.card.card_code}</Text>
        </View>
      }
      {
        errorResult &&
        <View style={tw`py-5`}>
          <Text style={tw`text-center text-base font-500 text-red-400`}>{errorResult}</Text>
        </View>
      }
    </View>
  )
}



export default function AccessControlPanelSettingsModal({ communityId, onRequestClose }) {
  const { data: panels } = useQuery({
    queryKey: ['community.control-panels', communityId],
    queryFn: () => api.get(`/communities/${communityId}/access/control-panels`).then(response => response.data),
  })

  const { data: doors } = useQuery({
    queryKey: ['community.doors', communityId],
    queryFn: () => api.get(`/communities/${communityId}/access/doors`).then(response => response.data),
  })



  return (
    <Modal visible onRequestClose={onRequestClose} style={{ modal: tw`w-90%` }}>
      <Text style={tw`text-xl text-center text-secondary font-500 mt-3`}>Panel de control</Text>

      <View style={tw`my-3 bg-gray-100 rounded-lg `}>
        {
          panels?.map(panel =>
            <ControlPanelDetail key={panel.uuid} panel={panel} communityId={communityId} />
          )
        }
      </View>

      <View style={tw`gap-y-3`}>
        {
          doors?.map(door =>
            <DoorRow key={door.uuid} door={door} communityId={communityId} />
          )
        }
      </View>
    </Modal>
  )
}